import styled from "styled-components";

export const Container = styled.div`
  max-width: ${({ large }) => (large ? "108rem" : "72.8rem")};
  width: 100%;
  padding: 0 2.4rem;
  margin: 4.8rem auto;

  ${({ theme }) => theme.media.sm`
    margin: 2.4rem 0;
  `}
`;

export const Title = styled.h1`
  font-size: 3rem;
  line-height: 3.5rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 2.4rem;

  ${({ theme }) => theme.media.sm`
    font-size: 2rem;
    line-height: 2.4rem;
  `}
`;

export const Description = styled.p`
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 600;
  color: #4b5563;
  margin: 0 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const SubTitle = styled.h2`
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 600;
  color: #181c24;
  margin-bottom: 1.6rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: 1.8rem;
  `}
`;

export const TextTitle = styled.h3`
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 600;
  color: #181c24;
  margin-bottom: 0.4rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Text = styled.p`
  font-size: ${({ small }) => (small ? "1.2rem" : "1.4rem")};
  line-height: ${({ small }) => (small ? "1.6rem" : "2rem")};
  font-weight: ${({ strong }) => (strong ? 600 : 400)};
  color: #4b5563;
  margin: 0;

  ${({ theme, small }) => theme.media.sm`
    font-size: ${small ? "1.3rem" : "1.5rem"};
    line-height: ${small ? "1.7rem" : "2rem"};
  `}
`;

export const PoweredByContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5rem;
`;

export const ChartCard = styled.div`
  width: 100%;
  padding: 2.4rem;
  background: #fff;
  border: 0.1rem solid #f3f4f6;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.36);
  backdrop-filter: blur(2.4rem);
  border-radius: 0.8rem;
`;

export const ProgressBarContainer = styled.div`
  margin-top: 2.4rem;

  > div:not(:first-child) {
    margin-top: 3.2rem;
  }
`;
